__turbopack_context__.v({
  "noTech": "NoTechnologyPlaceholder-module-scss-module__1rcBaG__noTech",
  "paragraph": "NoTechnologyPlaceholder-module-scss-module__1rcBaG__paragraph",
});
